<template lang='pug'>
div
    UHFSensorSelectorLinks

    div.fullwidth(v-if="$route.params.lang == 'en'")

        section.title-container
            h1.product-title UHF-PS1
            h2.product-subtitle Window-Type UHF PD Sensor for Integration into the Tank Wall of new Transformers

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-PS1.webp')
                        img( src='@/assets/photos/product_shots/UHF-PS1.png', width="100%", alt='Window-Type UHF Sensor UHF-PS1 ', title='Window-Type UHF Sensor UHF-PS1 ')
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li Window-type UHF PD sensor
                            li For oil-filled transformers
                            li Designed according to Cigré TB 662
                            li Bandwidth: 100 MHz ... 3 GHz
                            li Integrated high-pass filter
                            li High sensitivity
                    .bluebox
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet UHF-PS1.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-PS1', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/pdm-600-mobile", text='PDM-600-Mobile')
                        Sitelink(to="/en/products/transformerparts/overview", text='Transformer Parts for Window-Type UHF Sensors')
        
        section.margin-bottom
            p The window-type UHF PD sensor is used for measuring of the electromagnetic radiation from internal PD in ultra-high frequency range (UHF) in transformers.
            p Cigré Working Group WG A2-27 recommends to install DN50 valves or dielectric windows for later fitting of UHF probes. (Recommendations for condition monitoring and condition assessment facilities for transformers, TB 343). The dielectric window of the UHF-PS1 sensor is designed according to Cigré Working Group WG D1-37 (Guidelines for partial discharge detection using conventional and unconventional methods, TB 662).
           
        div.margin-bottom
            .column-container
                .column
                    p The window-type UHF sensor can be integrated directly into the tank wall of new transformers.
                    p For this, the sensor requires a   
                        a.backlink(href='/en/products/transformerparts/welding-ring-set') stainless steel welding ring
                        |  and a temperature stable, oil-durable  
                        a.backlink(href='/en/products/transformerparts/dielectric-window-set') dielectric window. 
                        |  The UHF sensor is inserted into this window from the outside without oil handling.
                        p Window sensors are suitable for permanent monitoring of partial discharges. Several window sensors can be installed on one transformer.
                        p This solution enables the oil-tight, vacuum capable integrity of the transformer while offering maximum flexibility in potential future installments of the UHF-PS1 and PD monitoring systems such as the PDM-600.
                .column.center-content
                    picture
                        source(type='image/webp', srcset='@/assets/photos/PS1_installed.webp')
                        img( src='@/assets/photos/PS1_installed.png', width="300px", alt='UHF PD sensor UHF-PS1 installed with transformer parts', title='UHF PD sensor UHF-PS1 installed with transformer parts')               
           


    div.fullwidth(v-if="$route.params.lang == 'de'")

        section.title-container
            h1.product-title UHF-PS1
            h2.product-subtitle UHF-Fenstersensor für die direkte Integration in neue Transformatoren

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-PS1.webp')
                        img( src='@/assets/photos/product_shots/UHF-PS1.png', width="100%", alt='Fenstersensor UHF-PS1', title='Fenstersensor UHF-PS1')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li UHF-TE-Sensor mit dielektrischem Fenster
                            li Für ölgefüllte Transformatoren
                            li Design gemäß Cigré TB 662
                            li Bandbreite: 100 MHz ... 3 GHz
                            li Integrierter Hochpassfilter
                            li Hohe Empfindlichkeit
                    .bluebox
                        Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet UHF-PS1.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-PS1', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/pdm-600-mobile", text='PDM-600-Mobile')
                        Sitelink(to="/de/products/transformerparts/overview", text='Transformatorteile für UHF-Fenstersensoren')
                    
        section.margin-bottom
            p Der UHF-TE-Sensor UHF-PS1 dient zur Messung der elektromagnetischen Abstrahlung von Teilentladungen (TE) im ultrahochfrequenten (UHF) Bereich im Transformator.
            p Die Cigré Arbeitsgruppe WG A3-27 empfiehlt DN50 Absperrschieber oder dielektrische Fenster für die spätere Installation von UHF-Sensoren vorzusehen. (Recommendations for condition monitoring and condition assessment facilities for transformers, TB 343).
            p Die dielektrischen Fenster des UHF-PS1 Sensors entsprechen der Vorgabe der Cigré Arbeitsgruppe WG D1-37 (Guidelines for partial discharge detection using conventional and unconventional methods, TB 662).
        
        div.margin-bottom
            .column-container
                .column
                    p Der UHF-Fenstersensor kann bei neuen Transformatoren direkt in die Kesselwand integriert werden.
                    p Der Sensor benötigt dafür einen  
                        a.backlink(href='/de/products/transformerparts/welding-ring-set') Edelstahlanschweißring 
                        |  und ein ölbeständiges, temperaturfestes 
                        a.backlink(href='/de/products/transformerparts/dielectric-window-set') dielektrisches Fenster, 
                        |  das auch als Ölsperre fungiert.
                    p In dieses Fenster wird der UHF-Sensor ohne Öl-Handling von außen eingesetzt.
                    p Fenstersensoren eignen sich für die dauerhafte Überwachung / Monitoring von Teilentladungen. Es können mehrere Fenstersensoren an einem Transformator installiert werden.
                    p Diese Lösung sorgt für die Öl- und Vakuumdichtigkeit des Transformators und ermöglicht maximale Flexibilität bei der Nachrüstung vom UHF-PS1 und TE-Monitoring-Systemen wie dem PDM-600.
                .column.center-content
                    picture
                        source(type='image/webp', srcset='@/assets/photos/PS1_installed.webp')
                        img( src='@/assets/photos/PS1_installed.png', width="300px", alt='UHF-TE-Sensor UHF-PS1 installiert auf Trafoteilen', title='UHF-TE-Sensor UHF-PS1 installiert auf Trafoteilen')    
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | UHF-PS1",
            description:
                "UHF-Fenstersensor für die direkte Integration in neue Transformatoren",
        },
        en: {
            title: "BSS | UHF-PS1",
            description:
                "Window-Type UHF PD Sensor for Integration into the Tank Wall of new Transformers",
        },
    },
};
</script>

<style scoped lang='sass'>
.backlink
    color: $color2
    text-decoration: none
    font-weight: bold
</style>